
export default superclass => class extends superclass  {
    stack = [];

    save() {
        let current = this.getCurrentCopy();
        this.stack.push(current);
        this.updateRedux();

        this.sendMessage("saved", this.getCurrentCopy());
    }

    getCurrentCopy() {
        return undefined;
    }

    restore(obj) {
        if (Array.isArray(obj)) {
            this.current = obj;
            return;
        }
        if (this.stack.length === 0) {
            return;
        }

        let rules = this.stack[this.stack.length - 1];
        
        this.current = this.getCurrentCopy(rules);
    }
}
